import storageFactory from './storageFactory';

export const localStorage = storageFactory('localStorage');

export const setCookie = (name: string, value: string, days: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
};

export const noop = (): void => {
};

export const capitalize = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);

export const getWidth = (): number => (
  window.innerWidth
  || document.documentElement.clientWidth
  || document.body.clientWidth
);

interface IEScript extends HTMLScriptElement {
  readyState?: string;
  onreadystatechange: (() => void) | null;
}

interface IEDocument extends Document {
  attachEvent(event: string, handler: () => void): void;
}

export const loadScript = (id: string, url: string, callback?: () => void): void => {
  const script = document.createElement('script');
  script.type = 'text/javascript';

  const ie = script as IEScript;

  if (ie.readyState) {
    ie.onreadystatechange = () => {
      if (ie.readyState === 'loaded' || ie.readyState === 'complete') {
        ie.onreadystatechange = null;
        script.id = id;

        if (typeof callback === 'function') {
          callback();
        }
      }
    };
  } else {
    script.onload = () => {
      script.id = id;

      if (typeof callback === 'function') {
        callback();
      }
    };
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const DOMReady = (callback: () => void): void => {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
    return;
  }

  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback);
    return;
  }

  const doc = document as IEDocument;

  if (doc.attachEvent) {
    doc.attachEvent('onreadystatechange', () => {
      if (document.readyState !== 'loading') {
        callback();
      }
    });
  }
};
